export default {
  methods: {
    tenantUrl: function (path) {
      const apiUrl = process.env.VUE_APP_STRATYA_SIGN_API_URL
      const baseUrl = apiUrl.replace('{tenant}', this.$route.params.tenant ? this.$route.params.tenant : 'base')
      return baseUrl + path
    }
  }
}
